export default __webpack_public_path__ + "static/media/badge-firstplayer.91c7a46b.png";